import { render, staticRenderFns } from "./ArchiveDocumentsModal.vue?vue&type=template&id=396f7ede&scoped=true&"
import script from "./ArchiveDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDocumentsModal.vue?vue&type=style&index=0&id=396f7ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396f7ede",
  null
  
)

export default component.exports